import { useCallback, useState } from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Page, Section, Stack } from 'ui';

import { SiteForm } from '../../components/SiteForm/SiteForm';

export const SiteEvidence = () => {
  const [selectedMaterial, setSelectedMaterial] = useState<number | undefined>(undefined);

  const onSiteMaterialChange = useCallback((id?: number) => setSelectedMaterial(id), []);

  return (
    <Page>
      <Page.Title title="Quality management" />
      <Page.Divider />
      <Section>
        <Stack rowGap={5}>
          <SiteForm onChange={onSiteMaterialChange} />
          <Box display="flex" justifyContent="flex-end">
            <Button
              variant="primary"
              size="large"
              component={Link}
              to={`/quality/${selectedMaterial}`}
              disabled={!selectedMaterial}
              data-testid="submit-button"
            >
              Manage
            </Button>
          </Box>
        </Stack>
      </Section>
    </Page>
  );
};
